<template>
  <div class="mb-8">
    <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
      <h3 class="text-lg font-semibold">Live</h3>
      <div class="flex flex-wrap items-center gap-3">
        <div class="text-xs text-gray-500">Auto-refreshing every 5s</div>
        <div class="flex flex-wrap items-center gap-2">
          <label class="text-sm text-gray-600">Window</label>
          <div class="flex flex-wrap gap-1">
            <button
              v-for="w in liveWindows"
              :key="w"
              @click="$emit('set-live-window', w)"
              :class="['px-2 py-1 rounded border text-xs', activeLiveWindow === w ? 'bg-black text-white border-black' : 'bg-white hover:bg-gray-50']"
            >
              {{ formatWindow(w) }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="liveLoading" class="grid grid-cols-1 md:grid-cols-3 gap-4 animate-pulse">
      <div class="rounded-xl p-5 border bg-white" v-for="i in 3" :key="`live-skeleton-${i}`">
        <div class="h-3 w-28 bg-gray-200 rounded mb-3"></div>
        <div class="h-7 w-20 bg-gray-300 rounded"></div>
      </div>
    </div>
    <div v-else-if="liveError" class="text-red-600 text-sm">{{ liveError }}</div>
    <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div class="rounded-xl p-5 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-sm">Active users</div>
        <div class="text-3xl font-semibold">{{ liveStats?.totals?.active_users || 0 }}</div>
      </div>
      <div class="rounded-xl p-5 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-sm mb-2">Top pages</div>
        <div v-if="!liveStats?.by_page?.length" class="text-sm text-gray-500">No data</div>
        <div v-else>
          <div v-for="row in liveStats.by_page.slice(0, 5)" :key="row.path" class="text-sm flex justify-between mb-1">
            <span class="truncate max-w-[220px]" :title="row.path">{{ row.path }}</span>
            <span>{{ row.users }}</span>
          </div>
        </div>
      </div>
      <div class="rounded-xl p-5 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-sm mb-2">Top countries</div>
        <div v-if="!liveStats?.by_country?.length" class="text-sm text-gray-500">No data</div>
        <div v-else>
          <div v-for="row in liveStats.by_country.slice(0, 5)" :key="row.country" class="text-sm flex justify-between mb-1">
            <span>{{ row.country }}</span>
            <span>{{ row.users }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EngagementLiveSection',
  props: {
    liveWindows: { type: Array, default: () => [] },
    activeLiveWindow: { type: Number, default: 30 },
    liveLoading: { type: Boolean, default: false },
    liveError: { type: String, default: '' },
    liveStats: { type: Object, default: null },
    formatWindowFn: { type: Function, required: true },
  },
  methods: {
    formatWindow(value) {
      return this.formatWindowFn(value)
    },
  },
}
</script>
